/** 日期字符串（YYYY-MM-DD）工具 */

/** 今天 YYYY-MM-DD */
export function today(): string {
  return new Date().toISOString().slice(0, 10);
}

/** 日期加 N 天，输出 YYYY-MM-DD */
export function shiftDate(dateStr: string, days: number): string {
  const d = new Date(dateStr);
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
}

/** 严格校验 YYYY-MM-DD */
export function isValidDate(dateStr: string): boolean {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateStr);
  if (!m) return false;
  const [, y, mo, d] = m;
  const date = new Date(dateStr);
  return (
    date.getFullYear() === Number(y) &&
    date.getMonth() === Number(mo) - 1 &&
    date.getDate() === Number(d)
  );
}

/** 友好日期展示（2024-01-01） */
export function formatDate(dateStr: string): string {
  return dateStr;
}
